import React, { useEffect, useState, useRef } from 'react'
import { Card, CardContent, Grid, IconButton } from '@mui/material'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'

export const HeatMapComponent = ({ data, xLabels, yLabels }) => {
    const containerRef = useRef(null)
    const [cellSize, setCellSize] = useState(50)
    const [monthIndex, setMonthIndex] = useState(0)

    useEffect(() => {
        const updateCellSize = () => {
            if (containerRef.current) {
                const containerWidth = containerRef.current.offsetWidth
                const newCellSize = Math.floor(containerWidth / 6) - 20 // 3 columns + 1 for margins
                setCellSize(newCellSize)
            }
        }

        updateCellSize()
        window.addEventListener('resize', updateCellSize)
        return () => window.removeEventListener('resize', updateCellSize)
    }, [])

    const handlePreviousMonth = () => {
        setMonthIndex((prevIndex) => Math.max(prevIndex - 1, 0))
    }

    const handleNextMonth = () => {
        setMonthIndex((prevIndex) => prevIndex + 1)
    }

    const styles = {
        heatmapContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '10px',
            justifyContent: 'center',
            height: '100%',
        },
        heatmapGrid: {
            display: 'flex',
            flexDirection: 'column',
        },
        heatmapRow: {
            display: 'flex',
            alignItems: 'center',
        },
        heatmapLabel: {
            width: `${cellSize}px`,
            textAlign: 'left',
            fontSize: '11px',
            padding: '4px',
        },
        heatmapCell: {
            width: `${cellSize}px`,
            height: `${cellSize}px`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '2px',
            border: '1px solid #ccc',
            fontSize: '11px',
            color: '#333',
            borderRadius: '4px',
        },
        heatmapXLabels: {
            marginLeft: `${cellSize}px`,
            display: 'flex',
            marginTop: '10px',
            fontSize: '11px',
        },
        heatmapXLabel: {
            width: `${cellSize}px`,
            textAlign: 'center',
            margin: '2px',
        },
        buttonContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            marginBottom: '10px',
        },
    }


    return (
        <Grid container spacing={2}>
            <Grid item md={12}>
                <Card style={{ height: 450, zIndex: 100 }}>
                    <CardContent
                        style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%' }}
                    >
                        <div style={styles.buttonContainer}>
                            Matrice (en %)
                            <div>
                                <IconButton onClick={handlePreviousMonth} disabled={monthIndex === 0}>
                                    <KeyboardArrowLeftIcon />
                                </IconButton>
                                <IconButton onClick={handleNextMonth} disabled={monthIndex == 6}>
                                    <KeyboardArrowRightIcon />
                                </IconButton>
                            </div>
                        </div>
                        <div ref={containerRef} style={styles.heatmapContainer}>
                            <div style={styles.heatmapGrid}>
                                {yLabels.map((yLabel, yIndex) => (
                                    <div key={yLabel} style={styles.heatmapRow}>
                                        <div style={styles.heatmapLabel}>{yLabel?.substr(0,4)}</div>
                                        {xLabels.slice(monthIndex, monthIndex + 6).map((xLabel, xIndex) => (
                                            <div
                                                key={xLabel}
                                                style={{
                                                    ...styles.heatmapCell,
                                                    backgroundColor: getColor(data[yIndex][xIndex + monthIndex]),
                                                    color:getColorFont(data[yIndex][xIndex + monthIndex]),
                                                }}
                                            >
                                                {data[yIndex][xIndex + monthIndex]}
                                            </div>
                                        ))}
                                    </div>
                                ))}
                            </div>
                            <div style={styles.heatmapXLabels}>
                                {xLabels.slice(monthIndex, monthIndex + 6).map((xLabel) => (
                                    <div key={xLabel} style={styles.heatmapXLabel}>
                                        {xLabel}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    )
}

const getColor = (value) => {
    if (value === 0) return '#f0f0f0'
    const alpha = value / 300
    return `rgba(12, 68, 111, ${alpha})`
}

const getColorFont = (value) => {
    if (value === 0) return 'black'
    const alpha = value / 300
    if (alpha > 0.5) return 'white'
    return "black"
}
